import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { StorageSettings } from 'src/app/utils/storage.settings';
import { AuthService, AuthData } from '@tesla/ng-auth';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { Constants } from '../constants';
import { DataService } from '../../services/data.service';
import { QueryExternalCommentUnReadDTO } from 'src/app/models/internal/query-external-comment-unread-dto';
import { NGXLogger } from 'ngx-logger';
import UIHelper from 'src/app/core/utility/ui-helper';
import Helper from 'src/app/core/utility/helper';

@Component({
  selector: 'tsl-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    public title = 'Packaging 2.0';
    public userName: string;
    public unreadMessageCount: number;
    public environment: string;
    public requestAccessUrl: string;
    public SupportTicketUrl: string;
    public locStorage = Constants.localStorageKeys;
    IsEmployee = false;

  constructor(private auth: AuthService,
    public storageSettings: StorageSettings,
    private authService: AuthService,
    public appSettings: AppSettings,
    private dataService: DataService,
    protected logger: NGXLogger,
    private localstorageService: LocalstorageService,
    private appGlobalDataService: AppGlobalDataService) {
        this.environment = this.appSettings.ENV;
        this.requestAccessUrl = this.appSettings.RequestAccessUrl;
        this.SupportTicketUrl = this.appSettings.SupportTicketUrl;
        UIHelper.updateLoggerConfig(appSettings, logger);
      }
  logout() {
    // TODO: review why dataservice emitlogout needed
    // this.dataService.emitLogOut(true);
    this.clearLocalStorageFields();
    this.authService.logout();
  }

  // typically to be used while logging out, this will clear the fields in local storage so that next time user logs in same values are not restored
  clearLocalStorageFields() {
    this.localstorageService.clear(this.locStorage.CorrelationId);
  }

  ngOnInit() {
    this.appGlobalDataService.UserDisplayName.subscribe(data => {
        if (data) {
        this.userName = data;
        this.localstorageService.store(this.locStorage.UserDisplayName, this.userName);
        }
    });

    if (!this.userName) {
        this.userName = this.localstorageService.retrieve(this.locStorage.UserDisplayName);
    }

    this.appGlobalDataService.IsEmployee.subscribe(data => {
      this.IsEmployee = (data === Constants.IsEmployeeCheckCode);
    });

    this.appGlobalDataService.UnreadMessageCount.subscribe(data => {
      if (data) {
        this.unreadMessageCount = data;
      }
  });

    // TMS-17419 Errors immediately after logging in. Consolidate user logging validation.
    if (this.IsEmployee &&
      Helper.CheckEmployeeLogin(this.storageSettings)) {
      this.appGlobalDataService.IsEmployee.subscribe(data => {
        if (data) {
          this.refreshUnreadMessageCountForEmployee();
        }
    });

    this.appGlobalDataService.UnreadMessageCount.subscribe(data => {
      if (data) {
        this.unreadMessageCount = data;
          }
      });
    }

  }

  refreshUnreadMessageCountForEmployee() {
    this.logger.debug('Fetching unread message count for Employee');
        const queryExternalCommentUnReadDTO: QueryExternalCommentUnReadDTO = new QueryExternalCommentUnReadDTO();
        this.dataService
  .getUnreadProposalExternalCommentCount(queryExternalCommentUnReadDTO)
  .subscribe((response: any) => {
    if (response != null) {
        this.appGlobalDataService.RefreshUnreadMessageCount(response.Data);
  }
});

}

    public displayEnvironmentRibbon(): boolean {
        return (this.appSettings.ENV !== 'PRD' && this.appSettings.ENV !== 'PROD' && this.appSettings.ENV !== 'Production' )
        && this.appSettings.ENV !== 'LOC';
    }
}
